export default "__VITE_ASSET__D4e5jgFh__"